import React from "react"; 
import "./styles.scss";
import Thumbimg from "../../assets/images/courses/course_thumb01.jpg"; 
import { Link } from "react-router-dom";
import { RiFileTextLine, RiTimeLine } from "react-icons/ri";
 
import PlayButtonImage from "../../assets/images/courses/PlayButtonImage.png"
import { secondsToHms } from "../../services/CommonService";


export default function SubscribedCourseCard({ course }) {

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "..."; // Add ellipsis to indicate truncation
    } else {
      return text;
    }
  };


  console.log(course.courseDuration, "Course Duration")



  const openCourse = () => {

  }

  return (
    <div className="coursescard-item" onClick={openCourse}>

      <div className="courses-thumb">
       {/*  <div
          className="courses-tags"
          style={{
            backgroundColor: course.board && course.board == 'ICSE' ? "#1363DF" : course.board && course.board == 'CBSE' ? "#1363DF" : course.board && course.board.length < 3 ? "#1363DF" : course.board && course.board.length < 6 ? "#1363DF" : course.board && course.board.length < 8 ? "#1363DF" : "#1363DF"
          }}
        >
          {course.board}/{course.grade}
        </div> */}
      </div>
      <div className="image-container">
        <div className="course-card-image">


          <Link to={`/learning/${course.courseId}`} >

            {course.courseImage ? (
              <>
                <img src={course.courseImage} alt="img" className="course-card-image" />
                <img src={PlayButtonImage} alt="img" className="hover-image" />
              </>
            ) : (
              <>
                <img src={Thumbimg} alt="img" className="course-card-image" />
                <img src={PlayButtonImage} alt="img" className="hover-image" />
              </>
            )}
          </Link>
        </div>
      </div>



      <div className="courses-content">
        <ul className="courses__item-meta list-wrap">
          <li>
            <i>
              <RiFileTextLine />
            </i>
            {course.courseModules.length + " Modules"}
          </li>
          <li>
            <i>
              <RiTimeLine />
            </i>
            {secondsToHms(course.courseDuration)}
            
            {/* 12h:20m */}
          </li>
          {/* <li>
              <i>
                <PiUsersLight />
              </i>
              Students
            </li> */}
        </ul>
        <h5 className="title">
          <Link to={`/learning/${course.courseId}`} >
            {truncateText(course.courseName, 40)}
          </Link>
        </h5>
        {/* <div className="d-flex flex-column">
          <div className="progress" style={{ height: 5 }}>
            <div className="progress-bar" role="progressbar"
              aria-valuemin="0" aria-valuemax="100" style={{ width: "0%", borderRadius: 99 }}>
            </div>
          </div>
          <span className="ext-dark fw-bold">0% Complete</span>
        </div> */}



        {/* <div className="courses__item-bottom">
          <Link to={`/learning/${course.id}`} >
            <button className="btn btn-primary">Resume</button>
          </Link>
        </div> */}
      </div>
    </div >
  );
}
